import { useSelector } from 'react-redux';
import { MainAppReducer } from 'Types';
import { normalizeScoreTheme } from 'Utils/ScoreTheme';

export const usePracticeScoreTheme = () =>
  useSelector((state: MainAppReducer) =>
    normalizeScoreTheme(
      state.mainAppReducer.userData?.practice_score_theme,
      state.mainAppReducer.userData?.practice_dark_mode,
    ),
  );
